import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../App.css";

const Details = ({ project }) => {
  const { handleShowModal } = useGlobalContext();

  const highlights1 = [
    "Excellent Connectivity",
    "Well-Planned Layouts",
    "Open Green Spaces",
  ];
  const highlights2 = [
    "Grand Entry Lobby",
    "Premium Amenities",
    "AIMS Hospital Just 3.5 km away",
  ];

  return (
    <section className="section shadow-sm lazyloaded text-center" id="overview">
      <h1 className="d-block section-heading color-primary text-capitalize text-center">
        {project} - Overview
      </h1>

      <p className="overview-para">
        Regency Anantam NXT is the latest addition to Regency Group's
        prestigious portfolio in Dombivli East. Following the massive success of
        Regency Anantam Phase 1, this new phase offers premium 1 & 2 BHK
        residences with world-class amenities and superior connectivity.
        Strategically located in Dombivli East, Regency Anantam NXT is
        surrounded by top schools, hospitals, shopping malls and transport hubs.
        Enjoy a seamless lifestyle with easy access to Mumbai, Thane and Navi
        Mumbai. Experience 60+ lifestyle amenities, lush green landscapes, and a
        vibrant gated community designed for comfort, convenience and luxury.
      </p>

      <center>
        <h3 className="mt-3" style={{ fontSize: "1.2rem" }}>
          {project} - Highlights
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights1.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights2.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <button
        className="chat-btn btn btn-info micro-form-btn effetGradient enqModal download_brochure"
        data-form="md"
        data-title="Download Brochure"
        data-btn="Download Now"
        data-enquiry="Download Brochure Welcome Text"
        data-redirect="brochure"
        data-redirect-file="brochure.pdf"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={() => handleShowModal("Overview - Download Brochure")}
      >
        <span className="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
